export default "__VITE_ASSET__DHemLAJV__"